import React from "react";
import Chart from "react-apexcharts";

const TreemapChartPreview = (props) => {
    const { height, seriesString, sizeString, occupations, colorRange } = props;

    // Función para interpolar colores
    const interpolateColor = (startColor, endColor, factor) => {
        const isValidHex = (color) => /^#([0-9A-Fa-f]{6})$/.test(color);

        const parseColor = (color) =>
            color.match(/\w\w/g).map((hex) => parseInt(hex, 16));

        // Validar colores y asignar #FFFFFF si son inválidos
        startColor = isValidHex(startColor) ? startColor : "#FFFFFF";
        endColor = isValidHex(endColor) ? endColor : "#FFFFFF";

        const [r1, g1, b1] = parseColor(startColor);
        const [r2, g2, b2] = parseColor(endColor);

        const r = Math.round(r1 + (r2 - r1) * factor);
        const g = Math.round(g1 + (g2 - g1) * factor);
        const b = Math.round(b1 + (b2 - b1) * factor);

        return `rgb(${r}, ${g}, ${b})`;
    };

    // Parseamos los strings a arrays
    const seriesLabels = seriesString.split(",").map((item) => item.trim());
    const sizes = sizeString.split(",").map((item) => parseInt(item.trim(), 10));

    // Combinar datos en un solo array para ordenar y procesar
    const combinedData = seriesLabels.map((label, index) => ({
        label,
        size: sizes[index],
        occupation: occupations[index],
        fillColor: interpolateColor("#"+(props.colorRange[0].replace("#","")), "#"+(props.colorRange[1].replace("#","")), occupations[index]),
    }));

    // Ordenar por tamaño de mayor a menor
    combinedData.sort((a, b) => b.size - a.size);

    // Generar series para el gráfico
    const series = [
        {
            data: combinedData.map(({ label, size, occupation, fillColor }) => ({
                x: label,
                y: size,
                occupation,
                fillColor,
            })),
        },
    ];

    // Configuración de ApexCharts
    const options = {
        chart: {
            type: "treemap",
            height: height,
        },
        plotOptions: {
            treemap: {
                distributed: true, // Distribuye colores individuales
                enableShades: false, // Deshabilita sombreado automático
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: "14px",
                        fontWeight: "bold",
                    },
                },
            },
        },
        tooltip: {
            enabled: true,
            custom: ({ seriesIndex, dataPointIndex, w }) => {
                const data = w.config.series[seriesIndex].data[dataPointIndex];
                return `
          <div style="padding: 8px; font-size: 14px;">
            <strong>${data.x}</strong><br />
            Occupation: ${(data.occupation * 100).toFixed(1)}%<br />
            Capacity: ${data.y}
          </div>
        `;
            },
        },
        colors: series[0].data.map((item) => item.fillColor), // Colores basados en ocupación
        title: {
            text: "",
            align: "center",
        },
    };

    return (
        <div style={{ width: "100%", height: height }}>
            <Chart options={options} series={series} type="treemap" height={height} />
        </div>
    );
};

export default TreemapChartPreview;
